var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/auth-login/components/registration-form.tsx";
import "core-js/modules/web.dom-collections.iterator.js";
import axios from 'axios';
import { Map as ImmutableMap } from 'immutable';
import debounce from 'lodash/debounce';
import React, { useState, useRef, useCallback } from 'react';
import { useIntl, FormattedMessage, defineMessages } from 'react-intl';
import { Link, useHistory } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { accountLookup } from 'soapbox/actions/accounts';
import { register, verifyCredentials } from 'soapbox/actions/auth';
import { openModal } from 'soapbox/actions/modals';
import BirthdayInput from 'soapbox/components/birthday-input';
import { Checkbox, Form, FormGroup, FormActions, Button, Input, Textarea } from 'soapbox/components/ui';
import CaptchaField from 'soapbox/features/auth-login/components/captcha';
import { useAppSelector, useAppDispatch, useSettings, useFeatures } from 'soapbox/hooks';
const messages = defineMessages({
  username: {
    "id": "registration.fields.username_placeholder",
    "defaultMessage": "Username"
  },
  username_hint: {
    "id": "registration.fields.username_hint",
    "defaultMessage": "Only letters, numbers, and underscores are allowed."
  },
  usernameUnavailable: {
    "id": "registration.username_unavailable",
    "defaultMessage": "Username is already taken."
  },
  email: {
    "id": "registration.fields.email_placeholder",
    "defaultMessage": "E-Mail address"
  },
  password: {
    "id": "registration.fields.password_placeholder",
    "defaultMessage": "Password"
  },
  passwordMismatch: {
    "id": "registration.password_mismatch",
    "defaultMessage": "Passwords don't match."
  },
  confirm: {
    "id": "registration.fields.confirm_placeholder",
    "defaultMessage": "Password (again)"
  },
  agreement: {
    "id": "registration.agreement",
    "defaultMessage": "I agree to the {tos}."
  },
  tos: {
    "id": "registration.tos",
    "defaultMessage": "Terms of Service"
  },
  close: {
    "id": "registration.confirmation_modal.close",
    "defaultMessage": "Close"
  },
  newsletter: {
    "id": "registration.newsletter",
    "defaultMessage": "Subscribe to newsletter."
  },
  needsConfirmationHeader: {
    "id": "confirmations.register.needs_confirmation.header",
    "defaultMessage": "Confirmation needed"
  },
  needsApprovalHeader: {
    "id": "confirmations.register.needs_approval.header",
    "defaultMessage": "Approval needed"
  }
});

/** Allows the user to sign up for the website. */
const RegistrationForm = _ref => {
  let {
    inviteToken
  } = _ref;
  const intl = useIntl();
  const history = useHistory();
  const dispatch = useAppDispatch();
  const settings = useSettings();
  const features = useFeatures();
  const instance = useAppSelector(state => state.instance);
  const locale = settings.get('locale');
  const needsConfirmation = !!instance.pleroma.getIn(['metadata', 'account_activation_required']);
  const needsApproval = instance.approval_required;
  const supportsEmailList = features.emailList;
  const supportsAccountLookup = features.accountLookup;
  const birthdayRequired = instance.pleroma.getIn(['metadata', 'birthday_required']);
  const [captchaLoading, setCaptchaLoading] = useState(true);
  const [submissionLoading, setSubmissionLoading] = useState(false);
  const [params, setParams] = useState(ImmutableMap());
  const [captchaIdempotencyKey, setCaptchaIdempotencyKey] = useState(uuidv4());
  const [usernameUnavailable, setUsernameUnavailable] = useState(false);
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [passwordMismatch, setPasswordMismatch] = useState(false);
  const source = useRef(axios.CancelToken.source());

  const refreshCancelToken = () => {
    source.current.cancel();
    source.current = axios.CancelToken.source();
    return source.current;
  };

  const updateParams = map => {
    setParams(params.merge(ImmutableMap(map)));
  };

  const onInputChange = e => {
    updateParams({
      [e.target.name]: e.target.value
    });
  };

  const onUsernameChange = e => {
    updateParams({
      username: e.target.value
    });
    setUsernameUnavailable(false);
    source.current.cancel();
    usernameAvailable(e.target.value);
  };

  const onCheckboxChange = e => {
    updateParams({
      [e.target.name]: e.target.checked
    });
  };

  const onPasswordChange = e => {
    const password = e.target.value;
    onInputChange(e);

    if (password === passwordConfirmation) {
      setPasswordMismatch(false);
    }
  };

  const onPasswordConfirmChange = e => {
    const password = params.get('password', '');
    const passwordConfirmation = e.target.value;
    setPasswordConfirmation(passwordConfirmation);

    if (password === passwordConfirmation) {
      setPasswordMismatch(false);
    }
  };

  const onPasswordConfirmBlur = () => {
    setPasswordMismatch(!passwordsMatch());
  };

  const onBirthdayChange = birthday => {
    updateParams({
      birthday
    });
  };

  const launchModal = () => {
    const message = /*#__PURE__*/React.createElement(React.Fragment, null, needsConfirmation && /*#__PURE__*/React.createElement("p", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 119,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "confirmations.register.needs_confirmation",
      defaultMessage: "Please check your inbox at {email} for confirmation instructions. You will need to verify your email address to continue.",
      values: {
        email: /*#__PURE__*/React.createElement("strong", {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 123,
            columnNumber: 28
          }
        }, params.get('email'))
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 120,
        columnNumber: 9
      }
    })), needsApproval && /*#__PURE__*/React.createElement("p", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 125,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "confirmations.register.needs_approval",
      defaultMessage: "Your account will be manually approved by an admin. Please be patient while we review your details.",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 126,
        columnNumber: 9
      }
    })));
    dispatch(openModal('CONFIRM', {
      icon: require('@tabler/icons/check.svg'),
      heading: needsConfirmation ? intl.formatMessage(messages.needsConfirmationHeader) : needsApproval ? intl.formatMessage(messages.needsApprovalHeader) : undefined,
      message,
      confirm: intl.formatMessage(messages.close)
    }));
  };

  const postRegisterAction = _ref2 => {
    let {
      access_token
    } = _ref2;

    if (needsConfirmation || needsApproval) {
      return launchModal();
    } else {
      return dispatch(verifyCredentials(access_token)).then(() => {
        history.push('/');
      });
    }
  };

  const passwordsMatch = () => {
    return params.get('password', '') === passwordConfirmation;
  };

  const usernameAvailable = useCallback(debounce(username => {
    if (!supportsAccountLookup) return;
    const source = refreshCancelToken();
    dispatch(accountLookup(username, source.token)).then(account => {
      setUsernameUnavailable(!!account);
    }).catch(error => {
      var _error$response;

      if (((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 404) {
        setUsernameUnavailable(false);
      }
    });
  }, 1000, {
    trailing: true
  }), []);

  const onSubmit = () => {
    if (!passwordsMatch()) {
      setPasswordMismatch(true);
      return;
    }

    const normalParams = params.withMutations(params => {
      // Locale for confirmation email
      params.set('locale', locale); // Pleroma invites

      if (inviteToken) {
        params.set('token', inviteToken);
      }
    });
    setSubmissionLoading(true);
    dispatch(register(normalParams.toJS())).then(postRegisterAction).catch(() => {
      setSubmissionLoading(false);
      refreshCaptcha();
    });
  };

  const onCaptchaClick = () => {
    refreshCaptcha();
  };

  const onFetchCaptcha = captcha => {
    setCaptchaLoading(false);
    updateParams({
      captcha_token: captcha.get('token'),
      captcha_answer_data: captcha.get('answer_data')
    });
  };

  const onFetchCaptchaFail = () => {
    setCaptchaLoading(false);
  };

  const refreshCaptcha = () => {
    setCaptchaIdempotencyKey(uuidv4());
    updateParams({
      captcha_solution: ''
    });
  };

  const isLoading = captchaLoading || submissionLoading;
  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit,
    "data-testid": "registrations-open",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 225,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("fieldset", {
    disabled: isLoading,
    className: "space-y-3",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 226,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(FormGroup, {
    hintText: intl.formatMessage(messages.username_hint),
    errors: usernameUnavailable ? [intl.formatMessage(messages.usernameUnavailable)] : undefined,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 227,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Input, {
    type: "text",
    name: "username",
    placeholder: intl.formatMessage(messages.username),
    autoComplete: "off",
    autoCorrect: "off",
    autoCapitalize: "off",
    pattern: "^[a-zA-Z\\d_-]+",
    onChange: onUsernameChange,
    value: params.get('username', ''),
    hasError: usernameUnavailable,
    required: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 231,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(Input, {
    type: "email",
    name: "email",
    placeholder: intl.formatMessage(messages.email),
    autoComplete: "off",
    autoCorrect: "off",
    autoCapitalize: "off",
    onChange: onInputChange,
    value: params.get('email', ''),
    required: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 246,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Input, {
    type: "password",
    name: "password",
    placeholder: intl.formatMessage(messages.password),
    autoComplete: "off",
    autoCorrect: "off",
    autoCapitalize: "off",
    onChange: onPasswordChange,
    value: params.get('password', ''),
    required: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 258,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(FormGroup, {
    errors: passwordMismatch ? [intl.formatMessage(messages.passwordMismatch)] : undefined,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 270,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Input, {
    type: "password",
    name: "password_confirmation",
    placeholder: intl.formatMessage(messages.confirm),
    autoComplete: "off",
    autoCorrect: "off",
    autoCapitalize: "off",
    onChange: onPasswordConfirmChange,
    onBlur: onPasswordConfirmBlur,
    value: passwordConfirmation,
    required: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 273,
      columnNumber: 11
    }
  })), birthdayRequired && /*#__PURE__*/React.createElement(BirthdayInput, {
    value: params.get('birthday'),
    onChange: onBirthdayChange,
    required: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 288,
      columnNumber: 11
    }
  }), needsApproval && /*#__PURE__*/React.createElement(FormGroup, {
    labelText: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "registration.reason",
      defaultMessage: "Why do you want to join?",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 297,
        columnNumber: 24
      }
    }),
    hintText: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "registration.reason_hint",
      defaultMessage: "This will help us review your application",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 298,
        columnNumber: 23
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 296,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Textarea, {
    name: "reason",
    maxLength: 500,
    onChange: onInputChange,
    value: params.get('reason', ''),
    required: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 300,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement(CaptchaField, {
    onFetch: onFetchCaptcha,
    onFetchFail: onFetchCaptchaFail,
    onChange: onInputChange,
    onClick: onCaptchaClick,
    idempotencyKey: captchaIdempotencyKey,
    name: "captcha_solution",
    value: params.get('captcha_solution', ''),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 310,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(FormGroup, {
    labelText: intl.formatMessage(messages.agreement, {
      tos: /*#__PURE__*/React.createElement(Link, {
        to: "/about/tos",
        target: "_blank",
        key: 0,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 321,
          columnNumber: 68
        }
      }, intl.formatMessage(messages.tos))
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 320,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Checkbox, {
    name: "agreement",
    onChange: onCheckboxChange,
    checked: params.get('agreement', false),
    required: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 323,
      columnNumber: 11
    }
  })), supportsEmailList && /*#__PURE__*/React.createElement(FormGroup, {
    labelText: intl.formatMessage(messages.newsletter),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 332,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Checkbox, {
    name: "accepts_email_list",
    onChange: onCheckboxChange,
    checked: params.get('accepts_email_list', false),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 333,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement(FormActions, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 341,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 342,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "registration.sign_up",
    defaultMessage: "Sign up",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 343,
      columnNumber: 13
    }
  })))));
};

export default RegistrationForm;